import React from 'react';
import { motion } from 'framer-motion';

const AcademicSourcesCarousel = () => {
  // TODAS LAS 52 FUENTES ACADÉMICAS REALES
  const allAcademicSources = [
    // APIs Directas (7 fuentes)
    { name: 'Crossref', logo: '🔬', color: 'from-blue-500 to-indigo-500', type: 'API Directa' },
    { name: 'arXiv', logo: '📄', color: 'from-red-500 to-orange-500', type: 'API Directa' },
    { name: 'PubMed', logo: '🏥', color: 'from-red-500 to-pink-500', type: 'API Directa' },
    { name: 'OpenAlex', logo: '🌐', color: 'from-purple-500 to-pink-500', type: 'API Directa' },
    { name: 'Semantic Scholar', logo: '🧠', color: 'from-indigo-500 to-purple-500', type: 'API Directa' },
    { name: 'Europe PMC', logo: '🏥', color: 'from-cyan-500 to-blue-500', type: 'API Directa' },
    { name: 'CORE', logo: '📚', color: 'from-blue-500 to-cyan-500', type: 'API Directa' },

    // Fuentes Principales (3 fuentes)
    { name: 'Google Scholar', logo: '🎓', color: 'from-blue-600 to-blue-700', type: 'Principal' },
    { name: 'ResearchGate', logo: '👥', color: 'from-teal-500 to-cyan-500', type: 'Principal' },
    { name: 'Academia.edu', logo: '🏛️', color: 'from-gray-600 to-gray-700', type: 'Principal' },

    // Acceso Abierto (3 fuentes)
    { name: 'DOAJ', logo: '📖', color: 'from-green-500 to-emerald-500', type: 'Acceso Abierto' },
    { name: 'BASE', logo: '🔍', color: 'from-yellow-500 to-orange-500', type: 'Acceso Abierto' },
    { name: 'DOAB', logo: '📗', color: 'from-emerald-600 to-green-600', type: 'Acceso Abierto' },

    // Regionales (5 fuentes)
    { name: 'SciELO', logo: '🌎', color: 'from-green-600 to-green-700', type: 'Regional' },
    { name: 'Redalyc', logo: '📊', color: 'from-red-600 to-pink-600', type: 'Regional' },
    { name: 'Dialnet', logo: '📋', color: 'from-orange-500 to-red-500', type: 'Regional' },
    { name: 'La Referencia', logo: '🔗', color: 'from-purple-600 to-indigo-600', type: 'Regional' },
    { name: 'REDIB', logo: '🌐', color: 'from-rose-500 to-red-500', type: 'Regional' },

    // Educativas (2 fuentes)
    { name: 'ERIC', logo: '📚', color: 'from-blue-500 to-purple-500', type: 'Educativa' },
    { name: 'TESEO', logo: '🎓', color: 'from-red-500 to-pink-500', type: 'Educativa' },

    // IA Académica (7 fuentes)
    { name: 'Consensus', logo: '🤝', color: 'from-emerald-500 to-teal-500', type: 'IA Académica' },
    { name: 'Elicit', logo: '🤖', color: 'from-violet-500 to-purple-600', type: 'IA Académica' },
    { name: 'Scite', logo: '📈', color: 'from-green-400 to-blue-500', type: 'IA Académica' },
    { name: 'SciSpace', logo: '🚀', color: 'from-purple-400 to-pink-400', type: 'IA Académica' },
    { name: 'Undermind AI', logo: '🔮', color: 'from-purple-500 to-violet-500', type: 'IA Académica' },
    { name: 'Perplexity AI', logo: '🔮', color: 'from-cyan-600 to-blue-600', type: 'IA' },
    { name: 'ORKG Ask', logo: '🧠', color: 'from-indigo-400 to-purple-400', type: 'IA Académica' },

    // Descubrimiento (4 fuentes)
    { name: 'Connected Papers', logo: '🔗', color: 'from-indigo-400 to-purple-400', type: 'Descubrimiento' },
    { name: 'Inciteful', logo: '📡', color: 'from-pink-500 to-rose-500', type: 'Descubrimiento' },
    { name: 'Research Rabbit', logo: '🐰', color: 'from-orange-400 to-red-400', type: 'Descubrimiento' },
    { name: 'Open Knowledge Maps', logo: '🗺️', color: 'from-indigo-600 to-blue-600', type: 'Descubrimiento' },

    // Especializadas (4 fuentes)
    { name: 'zbMATH', logo: '∑', color: 'from-teal-600 to-cyan-600', type: 'Especializada' },
    { name: 'ScienceOpen', logo: '🔬', color: 'from-blue-400 to-indigo-400', type: 'Especializada' },
    { name: 'The Lens', logo: '🔍', color: 'from-green-500 to-emerald-500', type: 'Especializada' },
    { name: 'Dimensions', logo: '📊', color: 'from-purple-500 to-indigo-500', type: 'Especializada' },

    // Preprints (2 fuentes)
    { name: 'bioRxiv', logo: '🧬', color: 'from-green-500 to-teal-500', type: 'Preprint' },
    { name: 'medRxiv', logo: '⚕️', color: 'from-red-500 to-pink-500', type: 'Preprint' },

    // Adicionales (3 fuentes)
    { name: 'Papers with Code', logo: '💻', color: 'from-blue-500 to-purple-500', type: 'Especializada' },
    { name: 'JURN', logo: '📰', color: 'from-amber-500 to-yellow-500', type: 'General' },
    { name: 'RefSeek', logo: '🔎', color: 'from-gray-500 to-slate-500', type: 'General' },

    // Comerciales (8 fuentes)
    { name: 'IEEE Xplore', logo: '⚡', color: 'from-blue-700 to-indigo-700', type: 'Comercial' },
    { name: 'Springer Link', logo: '📚', color: 'from-yellow-600 to-orange-600', type: 'Comercial' },
    { name: 'Wiley Online', logo: '📖', color: 'from-blue-800 to-purple-800', type: 'Comercial' },
    { name: 'Taylor & Francis', logo: '📑', color: 'from-red-700 to-pink-700', type: 'Comercial' },
    { name: 'SAGE Journals', logo: '🔰', color: 'from-green-700 to-emerald-700', type: 'Comercial' },
    { name: 'Oxford Academic', logo: '🎓', color: 'from-blue-900 to-indigo-900', type: 'Comercial' },
    { name: 'Cambridge Core', logo: '🏛️', color: 'from-blue-800 to-cyan-800', type: 'Comercial' },
    { name: 'MDPI', logo: '📊', color: 'from-orange-600 to-red-600', type: 'Comercial' }
  ];

  const totalSources = allAcademicSources.length;
  const directAPIs = allAcademicSources.filter(s => s.type === 'API Directa').length;

  // Triplicar las fuentes para scroll infinito seamless
  const duplicatedSources = [...allAcademicSources, ...allAcademicSources, ...allAcademicSources];

  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 dark:from-gray-800 dark:via-gray-700 dark:to-gray-800 rounded-2xl p-6">
      <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4 text-center">
        {totalSources} Fuentes académicas reales disponibles
      </h2>
      
      <div className="text-center mb-6">
        <div className="inline-flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {directAPIs} APIs Públicas Directas
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {totalSources - directAPIs} Fuentes Externas
            </span>
          </div>
        </div>
      </div>

      <div className="relative">
        {/* Gradient overlays para bordes suaves */}
        <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-indigo-50 via-indigo-50/90 to-transparent dark:from-gray-800 dark:via-gray-800/90 z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-indigo-50 via-indigo-50/90 to-transparent dark:from-gray-800 dark:via-gray-800/90 z-10 pointer-events-none"></div>

        {/* Contenedor de scroll */}
        <div className="overflow-hidden">
          <motion.div
            className="flex space-x-4"
            animate={{ x: [0, -4160] }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 80,
                ease: "linear",
              },
            }}
          >
            {duplicatedSources.map((source, index) => (
              <div
                key={`${source.name}-${index}`}
                className={`flex-shrink-0 px-3 py-2 bg-gradient-to-br ${source.color} rounded-lg shadow-md border border-white/20 w-40 h-20 backdrop-blur-sm`}
              >
                <div className="text-center text-white h-full flex flex-col justify-center items-center">
                  <div className="text-lg mb-1">{source.logo}</div>
                  <h3 className="font-semibold text-white text-xs leading-tight drop-shadow-lg">
                    {source.name}
                  </h3>
                  <span className="text-xs opacity-80 font-medium">
                    {source.type}
                  </span>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900 rounded-lg">
        <div className="flex items-start space-x-3">
          <span className="text-green-600 dark:text-green-300 text-lg">✅</span>
          <div className="text-sm text-green-700 dark:text-green-300">
            <p className="font-medium mb-1">Resultados 100% Reales y Auténticos de {totalSources} fuentes:</p>
            <ul className="list-disc list-inside space-y-1">
              <li><strong>{directAPIs} APIs públicas directas</strong> que devuelven documentos reales con URLs funcionales</li>
              <li><strong>{totalSources - directAPIs} fuentes externas</strong> con búsquedas exactas y parámetros optimizados</li>
              <li><strong>Sin contenido generado</strong> - Solo resultados de fuentes académicas verificadas</li>
              <li><strong>Enlaces que funcionan</strong> - Acceso directo a documentos completos o abstracts</li>
              <li><strong>Búsqueda multiidioma</strong> - Resultados en español, inglés y otros idiomas</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademicSourcesCarousel;